import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=5573baec&scoped=true&"
import script from "./deliver.vue?vue&type=script&lang=ts&"
export * from "./deliver.vue?vue&type=script&lang=ts&"
import style0 from "./deliver.vue?vue&type=style&index=0&id=5573baec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5573baec",
  null
  
)

export default component.exports